// @flow
import { combineReducers } from 'redux';
import { reducer as reduxFormReducer } from 'redux-form';

const rootReducer = combineReducers<_, *>({
  form: reduxFormReducer, // for redux-form user input data
});

export default rootReducer;
